<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>
export default {
  name: "ucenter"
};
</script>

<style lang="less">
body {
  font-family: -apple-system, "Helvetica Neue", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Zen Hei", sans-serif,
    Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  word-wrap: break-word;
}
.tab-container {
  margin-top: 2rem;
}
.van {
  &-panel {
    margin: 2rem 0;
  }
  &-card__img {
    height: 4rem;
    width: 4rem;
    box-shadow: #aaa 1px 1px 3px 0px;
    border: 1px solid #aaa;
    border-radius: 150px;
    padding: 2px;
  }
}
</style>
